import styled from '@emotion/styled';
import { Ui } from '@silvertours/front-shared';

const Container = styled(Ui.Card)`
  display: flex;
  overflow: hidden;
  font-family: ${({ theme }) => theme.fontFamily.default};
  font-weight: 600;
  line-height: 24px;
  font-size: 16px;

  ${({ theme }) => theme.mq('sm')} {
    font-family: ${({ theme }) => theme.fontFamily.alternate};
    font-weight: 700;
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: ${({ theme }) => theme.spacing[20]};
    ${({ theme }) => theme.mq('sm')} {
      padding: ${({ theme }) => theme.spacing[40]};
    }

    h2 {
      margin: 0;
      line-height: 24px;
      font-size: 16px;
    }

    a {
      font-family: ${({ theme }) => theme.fontFamily.default};
      color: ${({ theme }) => theme.colors.brand.green140};
      text-decoration: none;

      &:hover {
        color: ${({ theme }) => theme.colors.brand.green100};
      }

      &:focus-visible {
        border-radius: ${({ theme }) => theme.radius.xs};
        outline: 0.125rem dashed ${({ theme }) => theme.colors.brand.orange100};
        outline-offset: ${({ theme }) => theme.spacing[10]};
      }
    }
  }

  img {
    width: 116px;
    height: 116px;

    ${({ theme }) => theme.mq('sm')} {
      width: 144px;
      height: 144px;
    }
  }
`;

const LinkOnlyContainer = styled(Ui.Card)`
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-size: 1rem;
  background-color: ${({ theme }) => theme.colors.neutral.grey20};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: ${({ theme }) => theme.spacing[40]};

  a {
    color: ${({ theme }) => theme.colors.brand.green140};
    text-decoration: none;

    &:hover {
      color: ${({ theme }) => theme.colors.brand.green100};
    }
  }
`;

export { Container, LinkOnlyContainer };
